export default __webpack_public_path__ + "static/media/MP.ae7a207c.svg";